import { Component, inject } from '@angular/core';
import { GeneticMaterialOriginService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialOriginCreateDto,
  GeneticMaterialOriginDto,
  GeneticMaterialOriginExcelDownloadDto,
  GeneticMaterialOriginUpdateDto,
} from '../proxy/general/dtos/genetic-material-origin';
import { GENETICMATERIALORIGIN_CONFIG, GENETICMATERIALORIGIN_FIELDS } from './genetic-material-origin.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material-origin',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialOriginService, ConfirmationService],
  templateUrl: './genetic-material-origin.html',
  styleUrl: './genetic-material-origin.scss',
})
export class GeneticMaterialOrigin extends BaseCrudComponent<
  GeneticMaterialOriginDto,
  GeneticMaterialOriginCreateDto,
  GeneticMaterialOriginUpdateDto,
  GeneticMaterialOriginExcelDownloadDto
> {
  service = inject(GeneticMaterialOriginService);
  config = GENETICMATERIALORIGIN_CONFIG;
  fields = GENETICMATERIALORIGIN_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialOriginDto): GeneticMaterialOriginUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterialOrigin';
  }
}
